module.exports = __webpack_public_path__ + "img/category-skill-game.83050dc8.png";